import React from 'react'

import { Text } from '@mxenabled/mxui'

import type { SxProps } from '@mui/material'
import Stack from '@mui/material/Stack'

import { MiniDescriptionMUI } from './MiniDescriptionMUI'
import { DescriptionMUI } from './DescriptionMUI'

import type { Beat } from '../../../types/CommonBeat'

export interface ContentAndDescriptionMUIProps {
  asteriskText?: string
  beat: Beat
  children?: React.ReactNode
  descriptionPlacement?: 'top' | 'bottom'
  hideDescription?: boolean
  isLoading?: boolean
  isMini?: boolean
  hasFullWidthImage?: boolean
  sx?: SxProps
}

export const ContentAndDescriptionMUI: React.FC<ContentAndDescriptionMUIProps> = ({
  asteriskText,
  beat,
  children,
  descriptionPlacement = 'bottom',
  hideDescription = false,
  isLoading = false,
  isMini = false,
  hasFullWidthImage,
  sx,
}) => {
  const renderDescription = () => {
    if (hideDescription || !beat.html_description) return null
    return isMini ? (
      <MiniDescriptionMUI content={beat.html_description!} isLoading={isLoading} sx={sx} />
    ) : (
      <DescriptionMUI beat={beat} hasFullWidthImage={hasFullWidthImage} sx={sx} />
    )
  }

  return (
    <>
      {descriptionPlacement === 'top' && renderDescription()}
      {children && (
        <Stack sx={{ alignItems: 'center', ...(hasFullWidthImage && isMini && { mx: -16 }) }}>
          {children}
        </Stack>
      )}
      {descriptionPlacement === 'bottom' && renderDescription()}
      {asteriskText && (
        <Text
          sx={{
            color: 'text.secondary',
            display: 'block',
            pr: 8,
            textAlign: 'right',
          }}
          variant="caption"
        >
          {asteriskText}
        </Text>
      )}
    </>
  )
}
